import React, { Component } from "react";
import {
  Row,
  Col,
  InputGroup,
  Table,
  Button
} from "reactstrap";

import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import DatePicker from "react-datepicker";
import Pagination from "react-js-pagination";

import { storedb } from "../../client/storedb"

// Import actions
import * as actions from './actions'

class ActivityLogType extends Component {
  constructor(props) {
    super(props)
    let dbContext = storedb()
    this.state = {
      storeId: dbContext.getStoreId(),
    };
  }
  loadData = () => {
    const formData = {
      store_id: this.state.storeId,
      only_active: false
    }
    this.props.loadActivityTypes(formData)
  }
  updateStatus = (item) => {
    const formData = {
      status: !item.Enabled,
      type_id: item.Id
    }
    this.props.updateStatusType(formData, this.loadData)
  }
  componentDidMount() {
    this.loadData()
  }
  render() {
    const {
      activities: {
        requesting,
        activityTypes,
      },
    } = this.props
    
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting}>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" className="text-left table-border-right">Tên</th>
                    <th scope="col" width="130" className="text-center table-border-right">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {activityTypes && !!activityTypes.length && (
                    activityTypes.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-left table-border-right">{res.Name}</td>
                        <td className="text-center table-border-right">
                          {res.Enabled && (
                            <i className="fa fa-check-circle fa-2x text-success" onClick={e => this.updateStatus(res)}></i>
                          )}
                          {!res.Enabled && (
                            <i className="fa fa-close fa-2x text-error" onClick={e => this.updateStatus(res)}></i>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activities: state.activities,
});

const connected = connect(
  mapStateToProps,
  {
    loadActivityTypes: actions.loadActivityTypes,
    updateStatusType: actions.updateStatusType,
  }
)(ActivityLogType);

const formed = reduxForm({
  form: "orders"
})(connected);

export default formed;



// WEBPACK FOOTER //
// ./src/views/Admin/ActivityLog/ActivityLogType.js